<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <span class="d-flex mb-2">
            <i class="material-icons mr-1">trending_up</i>
            <d-col class="page-title p-0">
              <span class="ml-auto">Número de acesso: {{model.views || ''}}</span>
            </d-col>
          </span>
          <d-button class="btn-success btn-block" @click="printQr()">Imprimir QR Code</d-button>
          <d-button class="btn-danger btn-block" @click="deleteProduct()">Apagar</d-button>
          <d-button class="btn-info btn-block" @click="save('draft')">Salvar rascunho</d-button>
        </d-list-group-item>

      </d-list-group>
    </d-card-body>
    <d-card-footer class="border-top">
      <d-button class="btn-primary btn-block" @click="save('published')">{{ (model.status == 'published') ? 'Salvar' : 'Publicar' }}</d-button>
    </d-card-footer>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { MODEL, _OPEN_CONFIRMATION_ } from '_modules/product/components/ProductModel';

export default {
  name: 'sidebar-actions',
  props: {
    title: {
      type: String,
      default: 'Ações',
    },
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  computed: {
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'getRoles',
      'setToggle',
      'activeAlert',
      'updateTicket',
    ]),
    deleteProduct() {
      const params = {
        type: 'product',
        object: this.model,
        message: 'Produto deletado com sucesso!',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
    printQr() {
      this.$emit('printQr', this.model);
    },
    save(status) {
      this.model.status = status;
      this.$emit('save', this.model);
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
i.material-icons {
  top: 5px;
}
</style>
